// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"82":"c7c36e2d","154":"4545ceb8","387":"59e31f08","501":"423e0895","589":"a007028e","622":"ab4f8cea","643":"1d1519a3","773":"9f4b390b","858":"7b3ac6b8"}[chunkId] + ".chunk.js";
};